import React, { useRef } from "react";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import {
  DataGrid,
  RequiredRule,
  Column,
  Editing,
  Button,
  SearchPanel,
  Scrolling,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import useFetch from "../../Hooks/useFetch";
import ActionNotifications from "../../Components/ActionNotifications";
import ErrorMessage from "../../Components/ErrorMessage";

export default function CompaniesPage() {
  const {
      data: companyData,
      mutate,
      error,
    } = useSWR(`${apiBaseURL}/api/Company`),
    navigate = useNavigate(),
    fetch = useFetch(navigate),
    notifyResponse = useRef([]),
    showSpinner = useRef(false);

  const fetchSuccessful = (response) => {
    notifyResponse.current = response;
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };

  const renderGrid = () => {
    const onRowRemoved = async (e) => {
      console.log("row removed e", e);
      const response = await fetch.delete(
        `${apiBaseURL}/api/Company?id=${e.data.id}`
      );
      if (fetchSuccessful(response)) {
        mutate();
      }
      console.log(response);
    };

    const allowEditing = async (e) => {
      showSpinner.current = true;
      console.log(e);
      let response = null;
      let editType = e.changes.find((x) => x.type === "update");
      let addType = e.changes.find((x) => x.type === "insert");

      console.log(editType);
      console.log(addType);
      if (editType) {
        const editBody = {
          companyId: editType.data.id,
          companyName: editType.data.name,
          address: editType.data.address,
          city: editType.data.city,
          state: editType.data.state,
          zipCode: editType.data.zipCode,
        };
        response = await fetch.put(`${apiBaseURL}/api/Company`, editBody);
      } else if (addType) {
        const addBody = {
          companyName: addType.data.name,
          address: addType.data.address,
          city: addType?.data?.city,
          state: addType.data.state,
          zipCode: addType.data.zipCode,
        };
        response = await fetch.post(`${apiBaseURL}/api/Company`, addBody);
      } else {
        showSpinner.current = false;
        return;
      }

      if (fetchSuccessful(response)) {
        mutate();
      }
      showSpinner.current = false;
    };

    const onRowPrepared = (e) => {
      if (e.rowType === "header") {
        e.rowElement.style.backgroundColor = "#FFCD00";
        e.rowElement.style.fontWeight = "bold";
      }
    };

    return (
      <>
        <DataGrid
          dataSource={companyData}
          rowAlternationEnabled={false}
          height="80vh"
          showBorders={true}
          allowColumnResizing={true}
          columnAutoWidth={true}
          onSaved={allowEditing}
          onRowRemoved={onRowRemoved}
          onRowPrepared={onRowPrepared}
        >
          <SearchPanel
            visible={true}
            maxWidth={275}
            searchVisibleColumnsOnly={true}
            placeholder="Search..."
          />
          <Toolbar>
            <Item
              location="before"
              locateInMenu="never"
              render={() => (
                <div>
                  <h1 className="white">Companies</h1>
                </div>
              )}
            />
            <Item name="addRowButton" />
            <Item name="searchPanel" />
          </Toolbar>

          <Editing
            allowAdding={true}
            allowUpdating={true}
            allowDeleting={true}
          />
          <Scrolling mode="virtual" />
          <Column type="buttons">
            <Button name="edit" />
            <Button name="delete" />
          </Column>
          <Column
            dataField="id"
            width={150}
            alignment="left"
            allowEditing={false}
          >
            {" "}
          </Column>
          <Column dataField="name" minWidth={150}>
            {" "}
            <RequiredRule />{" "}
          </Column>
          <Column dataField="address">
            {" "}
            <RequiredRule />{" "}
          </Column>
          <Column dataField="city">
            {" "}
            <RequiredRule />{" "}
          </Column>
          <Column dataField="state">
            {" "}
            <RequiredRule />{" "}
          </Column>
          <Column dataField="zipCode">
            {" "}
            <RequiredRule />{" "}
          </Column>
        </DataGrid>
      </>
    );
  };

  if (!(companyData || error)) return <LoadingSpinnerModal show />;

  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={notifyResponse.current} />
      <LoadingSpinnerModal show={showSpinner.current} />
      <div className="px-2 page-content">
        <div className=" contentBox my-3">
          {!error ? <>{renderGrid()}</> : <ErrorMessage />}
        </div>
      </div>
    </div>
  );
}
